import { Fragment } from 'react';

import EditIcon from '@usas/ui-web/components/icons/EditIcon';
import DeleteIcon from '@usas/ui-web/components/icons/DeleteIcon';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const LargeGrid = ({ state, gridState, onEdit, onDelete }) => (
  <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
    <thead>
      <tr>
        <th>Course</th>
        <th>Priority</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {state.isObjLoaded !== true
        ? (<Fragment>
          {state.isObjLoading === true ?
            <tr>
              <td colSpan="3">Loading...</td>
            </tr> :
            <tr>
              <td colSpan="3">No Course Priorities</td>
            </tr>
          }
        </Fragment>
        ) : state.objData.omeMeetEntryCourse.length > 0 && gridState.sortedGridData.length > 0 ?
          gridState.sortedGridData.map((entryCourse, i) => (
            < tr key={entryCourse.omeMeetEntryCourseId || i} >
              <td>{entryCourse.course?.courseCode || ''}</td>
              <td>{entryCourse.priority >= 0 ? entryCourse.priority : ''}</td>
              <td>
                {onDelete &&
                  <button className={global.IconButtonMargin} type="button" onClick={(e) => onEdit(e, entryCourse.omeMeetEntryCourseId)}>
                    <EditIcon />
                  </button>}
                {onEdit &&
                  <button className={global.IconButtonMargin} type="button" onClick={(e) => onDelete(e, entryCourse)}>
                    <DeleteIcon />
                  </button>}
              </td>
            </tr>)
          ) : (
            <tr>
              <td colSpan="3">No Course Priorities</td>
            </tr>
          )
      }
    </tbody>
  </table >
);

const SmallGrid = ({ state, gridState, onEdit, onDelete }) => (
  <div className={[global.SmallTable, 'hidden-md hidden-lg'].join(' ')}>
    {state.isObjLoaded !== true
      ? (
        <div className={global.SmallTableRow}>
          <div className={global.SmallTableRowHead}>&nbsp;</div>
          <div className={global.SmallTableRowInfo}>
            {state.isObjLoading === true
              ? <div className={global.SmallTableRowLabels}>Loading...</div>
              : <div className={global.SmallTableRowLabels}>No Course Priorities</div>
            }
          </div>
        </div>
      )
      : state.objData.omeMeetEntryCourse.length > 0 && gridState.sortedGridData.length > 0 ?
        gridState.sortedGridData.map((entryCourse, i) => (
          <div className={global.SmallTableRow} key={entryCourse.omeMeetEntryCourseId || i}>
            <div className={global.SmallTableRowHead}>
              <span className='hidden-xs'></span>&nbsp;
              {onDelete &&
                <button className={global.IconButton} type="button" onClick={(e) => onDelete(e, entryCourse)}>
                  <DeleteIcon />
                </button>}
              {onEdit &&
                <button className={global.IconButtonMobileMargin} type="button" onClick={(e) => onEdit(e, entryCourse.omeMeetEntryCourseId)}>
                  <EditIcon />
                </button>}
            </div>
            <div className={global.SmallTableRowInfo}>
              <div className='row'>
                <div className={['col-xs-6 col-sm-3', global.SmallTableRowLabels].join(' ')}>Course</div>
                <div className={['col-xs-6 col-sm-3', global.SmallTableRowData].join(' ')}>{entryCourse.course?.courseCode || <span>&nbsp;</span>}</div>
                <div className={['col-xs-6 col-sm-3', global.SmallTableRowLabels].join(' ')}>Priority</div>
                <div className={['col-xs-6 col-sm-3', global.SmallTableRowData].join(' ')}>{entryCourse.priority >= 0 ? entryCourse.priority : <span>&nbsp;</span>}</div>
              </div>
            </div>
          </div>
        )
        )
        : (
          <div className={global.SmallTableRow}>
            <div className={global.SmallTableRowHead}>&nbsp;</div>
            <div className={global.SmallTableRowInfo}>
              <div className={global.SmallTableRowLabels}>No Course Priorities</div>
            </div>
          </div>
        )}
  </div >
);

const OmeMeetEntryCourseGrid = ({ omeMeetState, gridState, onEdit, onDelete }) => (
  <Fragment>
    <LargeGrid state={omeMeetState} gridState={gridState} onEdit={onEdit} onDelete={onDelete} />
    <SmallGrid state={omeMeetState} gridState={gridState} onEdit={onEdit} onDelete={onDelete} />
  </Fragment>
);

export default OmeMeetEntryCourseGrid;